module.exports = __webpack_public_path__ + "static/media/AlbertSans-Italic-VariableFont_wght.b07da2ef.ttf";